/* ══════════════════════════════════════════════════════════════════
   首屏轮播。三件事，没有第四件：

     1. 换片（点进度条 / 左右箭头 / 键盘左右 / 自动）
     2. 自动播的暂停 —— 悬停、聚焦、标签页切走、手动点暂停，都停
     3. **视频只在桌面接 src** —— 手机上放海报图，替顾客省流量；
        `prefers-reduced-motion` 也不接，那是用户说了「别动」

   幻灯片数量、当前是第几张全由 section 知道（本地 block，不是 theme block）——
   theme block 不知道自己排第几，轮播这种东西没法用它写。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESKTOP = window.matchMedia('(min-width: 769px)');

  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('.eb-hero__bar'));
    var interval = parseInt(root.dataset.autoplay || '0', 10);
    var i = 0;
    var timer = null;

    function show(next) {
      i = (next + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === i);
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      });
      /* 进度条重挂一次动画：光换 class 不会让 CSS 动画重头走 */
      bars.forEach(function (b, n) {
        b.classList.remove('is-on');
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      void root.offsetWidth;
      if (bars[i]) bars[i].classList.add('is-on');
      play();
    }

    function play() {
      clearTimeout(timer);
      if (!interval || slides.length < 2 || REDUCED.matches) return;
      if (root.classList.contains('is-paused')) return;
      timer = setTimeout(function () { show(i + 1); }, interval);
    }
    function pause(on) {
      root.classList.toggle('is-paused', on);
      if (on) { clearTimeout(timer); } else { play(); }
    }

    root.addEventListener('click', function (e) {
      var bar = e.target.closest('.eb-hero__bar');
      if (bar) return show(bars.indexOf(bar));
      if (e.target.closest('[data-hero-prev]')) return show(i - 1);
      if (e.target.closest('[data-hero-next]')) return show(i + 1);
      var toggle = e.target.closest('[data-hero-toggle]');
      if (toggle) {
        var paused = !root.classList.contains('is-paused');
        pause(paused);
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(i + 1);
      if (e.key === 'ArrowLeft') show(i - 1);
    });

    /* 悬停和聚焦都停：读一屏字的时候被换走，比不会自动播还糟 */
    if (interval) {
      root.addEventListener('mouseenter', function () { clearTimeout(timer); });
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', function () { clearTimeout(timer); });
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearTimeout(timer); } else { play(); }
      });
    }

    /* 视频：够宽、用户没说「别动」，才把 src 接上去 */
    function videos() {
      if (!DESKTOP.matches || REDUCED.matches) return;
      root.querySelectorAll('video[data-src]:not([src])').forEach(function (v) {
        v.src = v.dataset.src;
        v.play().catch(function () { /* 浏览器不让自动播就留着海报图 */ });
      });
    }
    videos();
    DESKTOP.addEventListener('change', videos);

    if (bars[0]) bars[0].classList.add('is-on');
    play();
  }

  document.querySelectorAll('[data-hero]').forEach(init);
  /* 编辑器里加一张幻灯片会重渲染整个 section */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero]').forEach(init);
  });
})();
